/* eslint-disable
    camelcase,
    consistent-return,
    no-return-assign,
    no-shadow
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import * as net from 'util/Net';
import notifications from 'notifications';
import * as keyboard from 'util/Keyboard';

class TagSelectModel extends Backbone.Model {
  static initClass() {
    /*
    Used to track the selected index.
    */
    this.prototype.defaults = {idx: -1};
  }
}
TagSelectModel.initClass();

class TagDropdown extends Backbone.View {
  static initClass() {
    this.prototype.events = {
      'click .tag-search': function (e) {
        return e.stopPropagation();
      },
      'click .tag-options input': 'selectTag',
      'input .tag-search': 'filterTagOptions',
      'keydown .tag-search': 'handleKeydown',
      'change input[type=checkbox]': 'showApply',
      'click .apply-tags': 'applyTags',
      'click .create-tag': 'createTag',
      'click li a': 'applySingleTag',
      'mouseenter li a': 'setSelectedByHover',
    };

    this.prototype.CHECKED = 1;
    this.prototype.UNCHECKED = 0;
    this.prototype.INDETERMINATE = -1;
  }

  initialize(options) {
    ({progress: this.progress} = options);
    this.selectModel = new TagSelectModel();
    this.listenTo(this.selectModel, 'change:idx', this.changeSelected);
    // eslint-disable-next-line no-restricted-syntax
    const showApply = _.bind(this.showApply, this);
    return (function ($el, showApply) {
      $.propHooks.checked = {
        set(input, checked) {
          input.checked = checked;
          if ($(input).parents($el).length > 0) {
            return showApply();
          }
        },
      };
      return ($.propHooks.indeterminate = {
        set(input, indeterminate) {
          input.indeterminate = indeterminate;
          if ($(input).parents($el).length > 0) {
            return showApply();
          }
        },
      });
    })(this.$el, showApply);
  }

  checkboxSame($checkbox) {
    return (
      ($checkbox.prop('indeterminate') && $checkbox.data('original') === this.INDETERMINATE) ||
      ($checkbox.prop('checked') && $checkbox.data('original') === this.CHECKED) ||
      (!$checkbox.prop('checked') && $checkbox.data('original') === this.UNCHECKED)
    );
  }

  showApply() {
    this.$el.find('.apply-tags').addClass('hidden');
    return (() => {
      const result = [];
      for (const el of Array.from(this.$el.find('input[type=checkbox]'))) {
        const $el = $(el);
        if (this.checkboxSame($el)) {
          continue;
        }
        this.$el.find('.apply-tags').removeClass('hidden');
        break;
      }
      return result;
    })();
  }

  selectTag(e) {
    return e.stopPropagation();
  }

  setSelectedByHover(e) {
    const $el = $(e.currentTarget).parent();
    const idx = this.$el.find('.tag-options li').not('.hidden').index($el);
    return this.selectModel.set('idx', idx);
  }

  changeSelected(model, idx) {
    this.$el.find('.tag-options li a.selected').removeClass('selected');
    if (idx >= 0) {
      const $li = this.$el.find('.tag-options li').not('.hidden').eq(idx);
      if ($li.length === 0) {
        return;
      }
      $li.find('a').addClass('selected');
      const $parent = $li.parent();
      if ($li[0].offsetTop + $li.height() > $parent[0].scrollTop + $parent.height()) {
        $parent[0].scrollTop = $li[0].offsetTop + $li.height() - $parent.height();
      }
      if ($li[0].offsetTop < $parent[0].scrollTop) {
        return ($parent[0].scrollTop = $li[0].offsetTop);
      }
    }
  }

  handleKeydown(e) {
    if (keyboard.isUpKey(e) || keyboard.isDownKey(e)) {
      let idx = this.selectModel.get('idx');
      const visibleLength = this.$el.find('.tag-options li').not('.hidden').length;
      if (keyboard.isUpKey(e)) {
        idx = (idx - 1 + visibleLength) % visibleLength;
      } else if (keyboard.isDownKey(e)) {
        idx = (idx + 1) % visibleLength;
      }
      this.selectModel.set('idx', idx);
      e.preventDefault();
    }
    if (keyboard.isEnterKey(e)) {
      if (this.$el.find('.tag-options li:not(.hidden)').length > 0) {
        this.applySingleTag(e);
      } else if (this.$el.find('.tag-search').val().length > 0) {
        this.createTag();
        this.close();
      }
    }
    if (keyboard.isEscapeKey(e)) {
      return this.close();
    }
  }

  close() {
    return this.$el.dropdown('toggle');
  }

  filterTagOptions(e) {
    const query = $(e.currentTarget).val().toLowerCase();
    if (query.length > 0) {
      this.$el.find('.tag-options li').each(function () {
        const tag = $(this).text().toLowerCase();
        if (tag.indexOf(query.toLowerCase()) === -1) {
          return $(this).addClass('hidden');
        } else {
          return $(this).removeClass('hidden');
        }
      });
      this.selectModel.set('idx', 0, {silent: true});
      this.selectModel.trigger('change:idx', this.selectModel, 0);
      const firstTag = this.$el.find('.tag-options li').not('.hidden').eq(0).text();
      if (query !== firstTag.toLowerCase()) {
        return this.$el.find('.create-tag').removeClass('disabled');
      } else {
        return this.$el.find('.create-tag').addClass('disabled');
      }
    } else {
      this.$el.find('.tag-options li.hidden').removeClass('hidden');
      return this.$el.find('.create-tag').addClass('disabled');
    }
  }

  applySingleTag(e) {
    e.preventDefault();
    e.stopPropagation();
    const $selected = this.$el.find('.tag-options li a.selected');
    const $checkbox = $selected.find('input');
    if ($checkbox.data('original') === this.INDETERMINATE) {
      // If originally indeterminate, toggle through three states.
      if ($checkbox.prop('indeterminate')) {
        return $checkbox.prop({
          indeterminate: false,
          checked: false,
        });
      } else if ($checkbox.prop('checked')) {
        return $checkbox.prop({
          checked: false,
          indeterminate: true,
        });
      } else {
        return $checkbox.prop({
          checked: true,
          indeterminate: false,
        });
      }
    } else {
      // Otherwise, just apply the opposite of the current state and close.
      return $checkbox.prop('checked', !$checkbox.prop('checked'));
    }
  }

  getAffected() {
    throw new Error('getAffected not implemented');
  }

  createTag() {
    const newTag = this.$el.find('.tag-search').val();
    const affected = this.getAffected();
    // eslint-disable-next-line no-restricted-syntax
    const sequence_ids = _.pluck(this.getAffected(), 'id');

    const {name, value} = this.getTagNameValue(newTag);
    const values = {};
    const add_if_not_exists = [];
    if (value != null) {
      values[name] = value;
    } else {
      add_if_not_exists.push(name);
    }
    net
      .postJSON({
        url: '/1/api/files/actions/tag',
        data: {
          ids: sequence_ids,
          toAdd: add_if_not_exists,
          toRemove: [],
          toRename: {},
          toSet: values,
        },
      })
      .done(({data}) => {
        for (const sequence of Array.from(affected)) {
          const datum = _.findWhere(data, {id: sequence.id});
          if (datum == null) {
            continue;
          }
          sequence.get('tags').reset(datum.tags);
        }
        notifications.success('Successfully added tag.');
      })
      .fail(notifications.notifyError);
    analytics.track('data_management', 'batch_modified_sequences', {
      type: 'created_tag',
      sequence_count: affected.length,
    });
  }

  getTagNameValue(string) {
    const tagRawSplit = string.split(':');
    const tagName = tagRawSplit.shift();
    const tagValue = tagRawSplit.join(':') || null;
    return {name: tagName, value: tagValue};
  }

  applyTags() {
    const add_if_not_exists = [];
    const remove = [];
    for (const el of Array.from(this.$el.find('input[type=checkbox]'))) {
      const $el = $(el);
      if (!this.checkboxSame($el)) {
        const tagName = $el.parent().text();
        if ($el.prop('checked')) {
          add_if_not_exists.push(tagName);
        } else {
          remove.push(tagName);
        }
      }
    }

    const affected = this.getAffected();
    // eslint-disable-next-line no-restricted-syntax
    const sequence_ids = _.pluck(affected, 'id');
    net
      .postJSON({
        url: '/1/api/files/actions/tag',
        data: {
          ids: sequence_ids,
          toAdd: add_if_not_exists,
          toRemove: remove,
          toRename: {},
          toSet: {},
        },
      })
      .done(({data}) => {
        for (const sequence of Array.from(affected)) {
          const datum = _.findWhere(data, {id: sequence.id});
          if (datum == null) {
            continue;
          }
          sequence.get('tags').reset(datum.tags);
        }
        notifications.success('Applied tags successfully.');
      })
      .fail(notifications.notifyError);
    analytics.track('DATA_MANAGEMENT', 'batch_modified_sequences', {
      type: 'applied_tags',
      sequence_count: affected.length,
      added_count: add_if_not_exists.length,
      removed_count: remove.length,
    });
  }

  open() {
    this.$el.find('.tag-search').val('').focus();
    this.selectModel.set('idx', -1);
    // Add checked or indeterminate to checkboxes based on tags of selected sequences.
    const tags = {};
    const selectedSequences = this.getAffected();
    for (const sequence of Array.from(selectedSequences)) {
      sequence.get('tags').each((tag) => {
        const tagName = tag.get('name');
        if (tags[tagName] == null) {
          tags[tagName] = 0;
        }
        return tags[tagName]++;
      });
    }
    const {CHECKED} = this;
    const {UNCHECKED} = this;
    const {INDETERMINATE} = this;
    this.$el.find('.tag-options li').each(function () {
      const tag = $(this).text();
      const tagCount = tags[tag] || 0;
      if (tagCount === 0) {
        $(this).find('input').prop('checked', false);
        return $(this).find('input').data('original', UNCHECKED);
      } else if (tagCount === selectedSequences.length) {
        $(this).find('input').prop('checked', true);
        return $(this).find('input').data('original', CHECKED);
      } else {
        $(this).find('input').prop('indeterminate', true);
        return $(this).find('input').data('original', INDETERMINATE);
      }
    });
    this.$el.find('.create-tag').addClass('disabled');
    this.$el.find('.apply-tags').addClass('hidden');
    return this.$el.find('.tag-options li.hidden').removeClass('hidden');
  }
}
TagDropdown.initClass();

export default TagDropdown;
